import Ajax from '../ajax';

const controller = 'pointCalculator';
export default {
  list: (filter) => Ajax('get', controller, filter),
  get: (id) => Ajax('get', `${controller}/${id}`),
  add: (data) => Ajax('post', controller, data),
  edit: (id, data) => Ajax('put', `${controller}/${id}`, data),
  enable: (id) => Ajax('put', `${controller}/${id}/enable`),
  disable: (id) => Ajax('put', `${controller}/${id}/disable`),
};
